import { createClient } from '@supabase/supabase-js';

// Create React App solo expone variables con prefijo REACT_APP_ y las
// incrusta en el bundle al compilar. Por eso aquí solo puede vivir la
// clave publicable, que está diseñada para ser pública y se protege con
// Row Level Security (ver supabase/setup.sql).
const SUPABASE_URL = process.env.REACT_APP_SUPABASE_URL;
const SUPABASE_KEY = process.env.REACT_APP_SUPABASE_PUBLISHABLE_KEY;
const BUCKET = process.env.REACT_APP_SUPABASE_BUCKET || 'catalogo';
const IMAGE_PREFIX = process.env.REACT_APP_SUPABASE_IMAGE_PREFIX || 'img';

if (!SUPABASE_URL || !SUPABASE_KEY) {
  // Falla de forma ruidosa y temprana: un .env ausente daría, si no,
  // errores de red confusos en cada pantalla.
  throw new Error(
    'Faltan REACT_APP_SUPABASE_URL o REACT_APP_SUPABASE_PUBLISHABLE_KEY. ' +
      'Copie .env.example a .env y complete los valores.'
  );
}

export const supabase = createClient(SUPABASE_URL, SUPABASE_KEY, {
  auth: {
    persistSession: true,
    autoRefreshToken: true,
    storageKey: 'siesa.admin.session',
  },
});

export const STORAGE_BASE = `${SUPABASE_URL}/storage/v1/object/public/${BUCKET}/${IMAGE_PREFIX}`;

/**
 * Construye la URL pública de una imagen del catálogo.
 * Los nombres pueden contener espacios y acentos, así que se codifican.
 */
export const imageUrl = name =>
  `${STORAGE_BASE}/${encodeURIComponent(String(name).trim())}`;

/**
 * La columna `imagen` guarda varios nombres separados por comas.
 * Devuelve solo los nombres, sin convertirlos en URL.
 */
export function parseImages(field) {
  if (!field) return [];
  return String(field)
    .split(',')
    .map(name => name.trim())
    .filter(Boolean);
}

/** Igual que parseImages, pero devuelve las URL públicas ya construidas. */
export const obtenerImagenes = field => parseImages(field).map(imageUrl);

export { BUCKET, IMAGE_PREFIX };
